import axios from 'axios'
import { cookies, logoutCookies } from '@/utils/cookies'
import router from '../../../router/index'
import { Notification } from 'element-ui'

function isTokenInvalidError(error) {
  if (error.response) {
    const { message } = error.response.data
    return message === 'jwt expired'
  }
  return null
}

function responseSuccessHandler(response) {
  return response.data
}

function logout() {
  Notification({
    title: `請重新登入`,
    message: `您的登入資訊已過期，請重新登入，以確保資料的正確性。`,
    type: 'warning',
    position: 'top-right',
    duration: 0,
  })
  API.defaults.headers.common['x-access-token'] = undefined
  logoutCookies()
  setTimeout(() => {
    // 需要區分是從網頁後台進入或是派車軟體小橘進入
    if (router.currentRoute.query.from === 'desktop') {
      router.replace({ name: 'ServiceLogin' })
    } else {
      router.replace({ name: 'Login' })
    }
  }, 3 * 1000)
}

function responseErrorHandler(error) {
  if (error.response && isTokenInvalidError(error) && cookies.get('user')) {
    logout()
  } else if (error.response && error.response.status >= 500) {
    alert('伺服器發生錯誤，請聯絡管理人員')
  } else if (error.code === 'ECONNABORTED') {
    console.log('api 請求逾時')
  }
  return Promise.reject(error)
}

function getBaseUrl() {
  var baseUrl = ''
  if (location.href.includes('localhost')) {
    baseUrl = 'https://staging.ap.gladmobile.com/'
  } else if (location.href.includes('staging.backstage.gladmobile.com')) {
    baseUrl = 'https://staging.ap.gladmobile.com/'
  } else if (location.href.includes('daisuki.backstage.gladmobile.com')) {
    baseUrl = 'https://test-fleet.gladmobile.com/'
  } else if (location.href.includes('staging-2.backstage.gladmobile.com')) {
    baseUrl = 'https://staging2.ap.gladmobile.com/'
  } else if (location.href.includes('backstage.gladmobile.com')) {
    baseUrl = 'https://test-fleet.gladmobile.com/'
  } else {
    baseUrl = 'https://' + window.location.hostname + '/'
  }
  return baseUrl
}

function getAPIUrl() {
  return getBaseUrl() + 'web/api/'
}

// 好孕系統的API比較不一樣 特殊處理
function getPregnantServiceUrl() {
  var baseUrl = ''
  if (location.href.includes('localhost')) {
    baseUrl = 'https://staging.ap.gladmobile.com/'
  } else if (location.href.includes('staging.backstage.gladmobile.com')) {
    baseUrl = 'https://staging.ap.gladmobile.com/'
  } else if (location.href.includes('daisuki.backstage.gladmobile.com')) {
    baseUrl = 'https://ap.gladmobile.com/'
  } else if (location.href.includes('staging-2.backstage.gladmobile.com')) {
    baseUrl = 'https://staging2.ap.gladmobile.com/'
  } else if (location.href.includes('backstage.gladmobile.com')) {
    baseUrl = 'https://ap.gladmobile.com/'
  } else {
    baseUrl = 'https://' + window.location.hostname + '/'
  }
  return baseUrl
}

const API = axios.create({
  baseURL: getAPIUrl(),
  timeout: 1000 * 65,
})

API.interceptors.request.use((config) => {
  if (!config.url.includes('login') && !cookies.get('user')) {
    logout()
  } else {
    API.defaults.headers.common['x-access-token'] = cookies.get('user')
    return config
  }
})
API.interceptors.response.use(responseSuccessHandler, responseErrorHandler)
API.getBaseUrl = getBaseUrl()
API.getAPIUrl = getAPIUrl()
API.getPregnantServiceUrl = getPregnantServiceUrl()
export default API



// WEBPACK FOOTER //
// ./src/assets/js/libs/API.js